<template>
  <div class="login-page">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-8 mx-auto">
          
          <div
            v-if="!registerActive"
            class="card login"
            v-bind:class="{ error: emptyFields }"
          >
            <img width="150" class="logoImage" src="../../public/logologin.png">
            <br>
            <h1>Sign In</h1>
            <form class="form-group" @submit.prevent="doLogin()">
              <input
                v-model="login"
                type="login"
                class="form-control"
                placeholder="Login"
                required
              />
              <input
                v-model="passwordLogin"
                type="password"
                class="form-control"
                placeholder="Password"
                required
              />
              <input type="submit" class="btn btn-primary" value="Login"/>
              <p>
                Don't have an account?
                <a
                  href="#"
                  @click="registerActive = !registerActive, emptyFields = false"
                  >Sign up here</a
                >
              </p>
              <!-- <p><a href="#">Forgot your password?</a></p> -->
            </form>
          </div>

          <div
            v-else
            class="card register"
            v-bind:class="{ error: emptyFields }"
          >
            <img width="150" class="logoImage" src="../../public/logologin.png">
            <br>
            <h1>Sign Up</h1>
            <form class="form-group" @submit.prevent="doRegister()">
              <input
                v-model="authkey"
                type="text"
                class="form-control"
                placeholder="Authkey"
                required
              />
              <input
                v-model="loginReg"
                type="text"
                class="form-control"
                placeholder="Login"
                required
              />
              <input
                v-model="usernameReg"
                type="text"
                class="form-control"
                placeholder="Full name"
                required
              />
              <input
                v-model="emailReg"
                type="email"
                class="form-control"
                placeholder="Email"
                required
              />
              <input
                v-model="passwordReg"
                type="password"
                class="form-control"
                placeholder="Password (min length 8)"
                minlength="8"
                required
              />
              <input
                v-model="confirmReg"
                type="password"
                class="form-control"
                placeholder="Confirm Password"
                minlength="8"
                required
              />
              <input
                type="submit"
                class="btn btn-primary"
              />
              <p>
                Already have an account?
                <a
                  href="#"
                  @click="
                    registerActive = !registerActive, emptyFields = false
                  "
                  >Sign in here</a
                >
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'
export default {
  name: "login",
  data() {
    return {
            registerActive: false,
            login: "",
            loginReg: "",
            passwordLogin: "",
            usernameReg: "",
            emailReg: "",
            passwordReg: "",
            confirmReg: "",
            authkey: "",
            emptyFields: false
        }
    },
    methods: {
        doLogin() {
          var me = this
          api.loginRequest(me.login, me.passwordLogin, me)
        },
        doRegister() {
            var me = this
            if (me.passwordReg != me.confirmReg) {
                return me.$notify({ group: 'notify', type: 'error', title: 'Error', text: 'Password is not valid', duration: 3000})
            }
            api.registrationRequest(me.loginReg, me.emailReg, me.passwordReg, me.usernameReg, me.authkey, function(req, res) {
              if (req) {
                me.$notify({ group: 'notify', type: 'success', title: 'Success', text: 'Registration success', duration: 3000})
                me.registerActive = false
              } else {
                me.$notify({ group: 'notify', type: 'error', title: 'Error', text: res.info, duration: 3000})
              }
            }, me) 
        }
    }      
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p {
  line-height: 1rem;
}

.card {
  padding: 20px;
  text-align: center;
}

.form-group input {
  margin-bottom: 20px;
}

.logoImage {
    align-self: center;
}

.login-page {
  align-items: center;
  display: flex;
  height: 100vh;
  background: linear-gradient(#cfdcff, #a7afff);
}

.login-page .fade-enter-active,
.login-page .fade-leave-active {
  transition: opacity 0.5s;
}
.login-page .fade-enter,
.login-page .fade-leave-to {
  opacity: 0;
}

.login-page h1 {
  margin-bottom: 1.5rem;
}

.error {
  animation-name: errorShake;
  animation-duration: 0.3s;
}

@keyframes errorShake {
  0% {
    transform: translateX(-25px);
  }
  25% {
    transform: translateX(25px);
  }
  50% {
    transform: translateX(-25px);
  }
  75% {
    transform: translateX(25px);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
